import React, { useEffect } from "react";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
const InterSchoolCorner = () => {
  useEffect(() => {
    document.title = "Inter School Corner -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Inter School Corner </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Inter School Corner Competition 2026-2027</h1>
            </div>
          </div>
          <div className="row">
            <div className="table-responsive maintable">
              <table className="table">
                <thead>
                  <tr>
                    <th>Sl No </th>
                    <th>Competition </th>{" "}
                    <th>School / Venue </th>
                    <th>Date </th>{" "}
                    <th>Last Date of Registration </th>
                    <th colspan="2">Event </th>{" "}
                    <th>Classes </th>
                    <th>No. of Participants </th>{" "}
                    <th>Teacher Incharge </th>
                    <th>Remarks </th>
                  </tr>
                </thead>
                <tbody>
  {/* 1 */}
  <tr>
    <td>1</td>
    <td>Gowardhan Dass Declamation Contest 2026</td>
    <td>Springdales School, Pusa Road</td>
    <td>30/04/2026</td>
    <td>14/04/2026</td>
    <td colSpan="2">Declamation</td>
    <td>XI-XII</td>
    <td>2</td>
    <td>TSC</td>
    <td></td>
  </tr>

  {/* 2 */}
  <tr>
    <td rowSpan="15">2</td>
    <td rowSpan="15">Abhivyakti 2026</td>
    <td rowSpan="15">Gyan Mandir Public School, Naraina</td>
    <td rowSpan="15">
      30-Apr-26 (Online event)
      <br />
      06-May-26 (Offline event)
    </td>
    <td rowSpan="15">16/04/2026</td>

    <td>a</td>
    <td>Chemart</td>
    <td>IX-X</td>
    <td>2</td>
    <td>MNG</td>
    <td></td>
  </tr>

  <tr>
    <td>b</td>
    <td>Frame Frenzy</td>
    <td>VI-VIII</td>
    <td>2</td>
    <td>TSC</td>
    <td></td>
  </tr>

  <tr>
    <td>c</td>
    <td>Next Gen</td>
    <td>VI-VIII</td>
    <td>2</td>
    <td>ASN</td>
    <td></td>
  </tr>

  <tr>
    <td>d</td>
    <td>Innospark</td>
    <td>VI-VIII</td>
    <td>2-3</td>
    <td>RSA</td>
    <td></td>
  </tr>

  <tr>
    <td>e</td>
    <td>Robo Grand Prix</td>
    <td>IX-XI</td>
    <td>2</td>
    <td>ASN</td>
    <td></td>
  </tr>

  <tr>
    <td>f</td>
    <td>Robo Warriors</td>
    <td>IX-XI</td>
    <td>2</td>
    <td>ASN</td>
    <td></td>
  </tr>

  <tr>
    <td>g</td>
    <td>Sanskrit Naad</td>
    <td>VI-VIII</td>
    <td>1</td>
    <td>PNM</td>
    <td></td>
  </tr>

  <tr>
    <td>h</td>
    <td>Goal Rush</td>
    <td>VI-VIII</td>
    <td>2</td>
    <td>MPP</td>
    <td></td>
  </tr>

  <tr>
    <td>i</td>
    <td>Vision in Frames</td>
    <td>VI-VIII</td>
    <td>2-3</td>
    <td>SHD</td>
    <td></td>
  </tr>

  <tr>
    <td>j</td>
    <td>Road Shield</td>
    <td>VIII-IX</td>
    <td>1</td>
    <td>MVJ</td>
    <td></td>
  </tr>

  <tr>
    <td>k</td>
    <td>Paryavaran Adalat</td>
    <td>IX-XII</td>
    <td>6-8</td>
    <td>PNM</td>
    <td></td>
  </tr>

  <tr>
    <td>l</td>
    <td>Bollywood Biz Bytes</td>
    <td>XI-XII</td>
    <td>2</td>
    <td>RSA</td>
    <td></td>
  </tr>

  <tr>
    <td>m</td>
    <td>Newsroom Nexus</td>
    <td>XI-XII</td>
    <td>3</td>
    <td>MPP</td>
    <td></td>
  </tr>

  <tr>
    <td>n</td>
    <td>Mathbiz Innovators</td>
    <td>XI-XII</td>
    <td>1</td>
    <td>VNS</td>
    <td></td>
  </tr>

  <tr>
    <td>o</td>
    <td>Sci-Genesis</td>
    <td>VI-VIII</td>
    <td>2</td>
    <td>PYM</td>
    <td></td>
  </tr>

  {/* 3 */}
  <tr>
    <td rowSpan="6">3</td>
    <td rowSpan="6">Art Poetica 2026</td>
    <td rowSpan="6">DPS, RK Puram</td>
    <td rowSpan="6">16/05/2026</td>
    <td rowSpan="6">18/04/2026</td>

    <td>a</td>
    <td>Blend Art</td>
    <td>IX-XII</td>
    <td>1</td>
    <td rowSpan="6">TSC</td>
    <td></td>
  </tr>

  <tr>
    <td>b</td>
    <td>Artistic Poesy</td>
    <td>IX-XII</td>
    <td>1</td>
    <td></td>
  </tr>

  <tr>
    <td>c</td>
    <td>Lyrical Canvas</td>
    <td>IX-XII</td>
    <td>1</td>
    <td></td>
  </tr>

  <tr>
    <td>d</td>
    <td>Inverse Rhapsody</td>
    <td>VI-VIII</td>
    <td>2</td>
    <td></td>
  </tr>

  <tr>
    <td>e</td>
    <td>Stage-a-Verse</td>
    <td>IX-XII</td>
    <td>2</td>
    <td></td>
  </tr>

  <tr>
    <td>f</td>
    <td>Poetic Silhouette</td>
    <td>VI-VIII</td>
    <td>1</td>
    <td></td>
  </tr>

  {/* 4 */}
  <tr>
    <td rowSpan="4">4</td>
    <td rowSpan="4">Rendezvous 2026</td>
    <td rowSpan="4">Air Force Bal Bharti School, Lodhi Road</td>
    <td rowSpan="4">22-Apr-26 - 23-Apr-26</td>
    <td rowSpan="4">18/04/2026</td>

    <td>a</td>
    <td>Global Newsroom</td>
    <td>IX-XII</td>
    <td>5</td>
    <td>PYM</td>
    <td></td>
  </tr>

  <tr>
    <td>b</td>
    <td>Pitch Arena</td>
    <td>XI-XII</td>
    <td>3-5</td>
    <td>RSA</td>
    <td></td>
  </tr>

  <tr>
    <td>c</td>
    <td>The Quest</td>
    <td>IX-XII</td>
    <td>2</td>
    <td>PYM</td>
    <td></td>
  </tr>

  <tr>
    <td>d</td>
    <td>Best Out of Waste</td>
    <td>VI-IX</td>
    <td>2</td>
    <td>PYR</td>
    <td></td>
  </tr>

  {/* 5 */}
  <tr>
    <td rowSpan="7">5</td>
    <td rowSpan="7">Ubharte Hastakshar 2026</td>
    <td rowSpan="7">SBDAV, Vasant Vihar</td>
    <td rowSpan="7">27-Apr-26 (Online entries submission)</td>
    <td rowSpan="7">20/04/2026</td>

    <td>a</td>
    <td>Art for Peace</td>
    <td>IX-XII</td>
    <td>1</td>
    <td>MVJ</td>
    <td></td>
  </tr>

  <tr>
    <td>b</td>
    <td>Voices Unbound</td>
    <td>VI-VIII</td>
    <td>1</td>
    <td>TSC</td>
    <td></td>
  </tr>

  <tr>
    <td>c</td>
    <td>Voices of Harmony</td>
    <td>VI-VIII</td>
    <td>1</td>
    <td>RKS</td>
    <td></td>
  </tr>

  <tr>
    <td>d</td>
    <td>Rhythm for Peace</td>
    <td>IX-X</td>
    <td>2</td>
    <td>SKM</td>
    <td></td>
  </tr>

  <tr>
    <td>e</td>
    <td>Peace in Practice</td>
    <td>VI-VIII</td>
    <td>1</td>
    <td>MPP</td>
    <td></td>
  </tr>

  <tr>
    <td>f</td>
    <td>Mind Matters - Peace Within</td>
    <td>IX-XII</td>
    <td>1</td>
    <td>BSH</td>
    <td></td>
  </tr>

  <tr>
    <td>g</td>
    <td>Innovate for Peace</td>
    <td>IX-XII</td>
    <td>2</td>
    <td>BSH</td>
    <td></td>
  </tr>

  {/* 6 */}
  <tr>
    <td>6</td>
    <td>Ordinatrix 2026</td>
    <td>Tagore International School, Vasant Vihar</td>
    <td>12/05/2026</td>
    <td>25/04/2026</td>
    <td colSpan="2">Ordinatrix Events</td>
    <td>VI-XII</td>
    <td>4-5</td>
    <td>NEG</td>
    <td></td>
  </tr>

  {/* 7 */}
  <tr>
    <td>7</td>
    <td>Debatable 2026</td>
    <td>Apeejay School, Panchsheel Park</td>
    <td>14/05/2026</td>
    <td>04/05/2026</td>
    <td colSpan="2">Debatable Events</td>
    <td>IX-XII</td>
    <td>2</td>
    <td>TSC</td>
    <td></td>
  </tr>

  {/* 8 */}
  <tr>
    <td rowSpan="4">8</td>
    <td rowSpan="4">Polaroid 7.0</td>
    <td rowSpan="4">Tagore International School, East of Kailash</td>
    <td rowSpan="4">14/05/2026</td>
    <td rowSpan="4">30/04/2026</td>

    <td>a</td>
    <td>Inverso</td>
    <td>IX-XII</td>
    <td>4</td>
    <td>KAN</td>
    <td></td>
  </tr>

  <tr>
    <td>b</td>
    <td>Perception</td>
    <td>IX-XII</td>
    <td>2-4</td>
    <td>TSC</td>
    <td></td>
  </tr>

  <tr>
    <td>c</td>
    <td>Vestige</td>
    <td>VI-XII</td>
    <td>3</td>
    <td>KAN</td>
    <td></td>
  </tr>

  <tr>
    <td>d</td>
    <td>Sync</td>
    <td>IX-XII</td>
    <td>2</td>
    <td>NEG</td>
    <td></td>
  </tr>

  {/* 9 */}
  <tr>
    <td rowSpan="2">9</td>
    <td rowSpan="2">Impulse 2026</td>
    <td rowSpan="2">Apeejay School, Saket</td>
    <td rowSpan="2">13-May-26</td>
    <td rowSpan="2">06-May-26</td>

    <td>a</td>
    <td>Design @ AI</td>
    <td>VI-XII</td>
    <td>2</td>
    <td>NEG</td>
    <td></td>
  </tr>

  <tr>
    <td>b</td>
    <td>GD @ AI</td>
    <td>IX-XII</td>
    <td>2</td>
    <td>NEG</td>
    <td></td>
  </tr>

  {/* 10 */}
  <tr>
    <td rowSpan="2">10</td>
    <td rowSpan="2">Tinkerfest 2026</td>
    <td rowSpan="2">Suraj Bhan DAV School, Vasant Vihar</td>
    <td rowSpan="2">18-May-26</td>
    <td rowSpan="2">10-May-26</td>

    <td>a</td>
    <td>Measure, Monitor, Minimize</td>
    <td>IX-X</td>
    <td>2</td>
    <td>MNG</td>
    <td></td>
  </tr>

  <tr>
    <td>b</td>
    <td>Safety for People</td>
    <td>VIII-IX</td>
    <td>2</td>
    <td>ASN</td>
    <td></td>
  </tr>

  {/* 11 */}
  <tr>
    <td rowSpan="2">11</td>
    <td rowSpan="2">DXC 2026</td>
    <td rowSpan="2">DPS, RK Puram</td>
    <td rowSpan="2">23-May-26</td>
    <td rowSpan="2">20-May-26</td>

    <td colSpan="2">Phonescape</td>
    <td>VI-VIII</td>
    <td>2</td>
    <td>HIR</td>
    <td></td>
  </tr>

  <tr>
    <td colSpan="2">Phonescape</td>
    <td>IX-XII</td>
    <td>2</td>
    <td>HIR</td>
    <td></td>
  </tr>

  {/* 12 */}
  <tr>
    <td rowSpan="2">12</td>
    <td rowSpan="2">Ubuntu 2026</td>
    <td rowSpan="2">Ramjas School, Anand Parbat</td>
    <td rowSpan="2">27-Jul-26 29-Jul-26</td>
    <td rowSpan="2">6-Jul-26</td>

    <td>a</td>
    <td>Ramcharit Manas</td>
    <td>VI-VIII</td>
    <td>4</td>
    <td>PNM</td>
    <td></td>
  </tr>

  <tr>
    <td>b</td>
    <td>Antyakshari</td>
    <td>IX-XII</td>
    <td>4</td>
    <td></td>
    <td></td>
  </tr>

  {/* 13 */}
  <tr>
    <td rowSpan="12">13</td>
    <td rowSpan="12">Iridescence 2026</td>
    <td rowSpan="12">Carmel Convent School, Chanakyapuri</td>
    <td rowSpan="12">21-Jul-26 24-Jul-26</td>
    <td rowSpan="12">17-Jul-26</td>

    <td>a</td>
    <td>Renaissance</td>
    <td>VIII-X</td>
    <td>6-8</td>
    <td>SHD</td>
    <td></td>
  </tr>

  <tr>
    <td>b</td>
    <td>English Debate</td>
    <td>IX-XII</td>
    <td>3</td>
    <td>TSC</td>
    <td></td>
  </tr>

  <tr>
    <td>c</td>
    <td>Devil's Advocate</td>
    <td>VI-VIII</td>
    <td>1</td>
    <td>TSC</td>
    <td></td>
  </tr>

  <tr>
    <td>d</td>
    <td>Meraki</td>
    <td>VIII-XII</td>
    <td>8-12</td>
    <td>SRK</td>
    <td></td>
  </tr>

  <tr>
    <td>e</td>
    <td>An ode to Mark twain</td>
    <td>VI-VIII</td>
    <td>2</td>
    <td>TSC</td>
    <td></td>
  </tr>

  <tr>
    <td>f</td>
    <td>Shutterbug</td>
    <td>XI-XII</td>
    <td>2</td>
    <td>HIR/KAN</td>
    <td></td>
  </tr>

  <tr>
    <td>g</td>
    <td>Nukkad Natak</td>
    <td>IX-XII</td>
    <td>12</td>
    <td>PNM</td>
    <td></td>
  </tr>

  <tr>
    <td>h</td>
    <td>Melange</td>
    <td>IX-XII</td>
    <td>2</td>
    <td>NEG</td>
    <td></td>
  </tr>

  <tr>
    <td>i</td>
    <td>Slam Poetry</td>
    <td>X-XII</td>
    <td>1</td>
    <td>TSC</td>
    <td></td>
  </tr>

  <tr>
    <td>j</td>
    <td>Capture the market</td>
    <td>XI-XII</td>
    <td>6</td>
    <td>NBH</td>
    <td></td>
  </tr>

  <tr>
    <td>k</td>
    <td>Impressionist</td>
    <td>VIII-XII</td>
    <td>3</td>
    <td>MVJ</td>
    <td></td>
  </tr>

  <tr>
    <td>l</td>
    <td>Science Spontania</td>
    <td>XII</td>
    <td>2</td>
    <td>ASN</td>
    <td></td>
  </tr>

  {/* 14 */}
  <tr>
    <td rowSpan="4">14</td>
    <td rowSpan="4">Confluence 2026</td>
    <td rowSpan="4">AFGJI, Subroto park</td>
    <td rowSpan="4">31-Jul-26</td>
    <td rowSpan="4">14-Jul-26</td>

    <td>a</td>
    <td>Thespian Coliseum</td>
    <td>IX-XI</td>
    <td>1</td>
    <td>TSC</td>
    <td></td>
  </tr>

  <tr>
    <td>b</td>
    <td>Poster Making</td>
    <td>VI-VIII</td>
    <td>2</td>
    <td>MVJ</td>
    <td></td>
  </tr>

  <tr>
    <td>c</td>
    <td>Cartoon Strip Pratyogita</td>
    <td>IX-XII</td>
    <td>2</td>
    <td>PNM</td>
    <td></td>
  </tr>

  <tr>
    <td>d</td>
    <td>Sanskrit Shlok Gayan</td>
    <td>VI-VIII</td>
    <td>1</td>
    <td>PNM</td>
    <td></td>
  </tr>

  {/* 15 */}
  <tr>
    <td rowSpan="15">15</td>
    <td rowSpan="15">Interact 2026</td>
    <td rowSpan="15">Carmel Convent School, Anand Niketan</td>
    <td rowSpan="15">29-31 Jul 26</td>
    <td rowSpan="15">25-Jul-26</td>

    <td>a.</td>
    <td>Ecoscape Creations</td>
    <td>VI-XII</td>
    <td>2</td>
    <td>PST</td>
    <td></td>
  </tr>

  <tr>
    <td>b.</td>
    <td>AI Pitch Tank</td>
    <td>IX-XII</td>
    <td>2</td>
    <td>NEG</td>
    <td></td>
  </tr>

  <tr>
    <td>c.</td>
    <td>Click & Capture</td>
    <td>VIII-XII</td>
    <td>1</td>
    <td>HIR/KAN</td>
    <td></td>
  </tr>

  <tr>
    <td>d.</td>
    <td>Scratch Story</td>
    <td>VI-VIII</td>
    <td>1</td>
    <td>NEG</td>
    <td></td>
  </tr>

  <tr>
    <td>e.</td>
    <td>Poster Making in Canva</td>
    <td>VII-VIII</td>
    <td>1</td>
    <td>NEG</td>
    <td></td>
  </tr>

  <tr>
    <td>f.</td>
    <td>Shakespearean Monologues</td>
    <td>IX-XI</td>
    <td>2</td>
    <td>TSC</td>
    <td></td>
  </tr>

  <tr>
    <td>g.</td>
    <td>Craftanza</td>
    <td>IX-XII</td>
    <td>2</td>
    <td>TMG</td>
    <td></td>
  </tr>

  <tr>
    <td>h.</td>
    <td>Impact to Profit Pitch</td>
    <td>IX-XII</td>
    <td>2</td>
    <td>RSA</td>
    <td></td>
  </tr>

  <tr>
    <td>i.</td>
    <td>Innovation Expo</td>
    <td>IX-XII</td>
    <td>2</td>
    <td>RSA</td>
    <td></td>
  </tr>

  <tr>
    <td>j.</td>
    <td>Cupcake Canvas</td>
    <td>VI-VIII</td>
    <td>2</td>
    <td>NBH</td>
    <td></td>
  </tr>

  <tr>
    <td>k.</td>
    <td>Intuitive Ideas</td>
    <td>VII-IX</td>
    <td>2</td>
    <td>MVJ</td>
    <td></td>
  </tr>

  <tr>
    <td>l.</td>
    <td>Stitch & Blossom</td>
    <td>VII-IX</td>
    <td>2</td>
    <td>NBH</td>
    <td></td>
  </tr>

  <tr>
    <td>m.</td>
    <td>Sanskritayanam</td>
    <td>
      (i) VI-VIII
      <br />
      (ii) IX-XII
    </td>
    <td>
      2
      <br />
      2
    </td>
    <td>PNM</td>
    <td></td>
  </tr>

  <tr>
    <td>n.</td>
    <td>Garden on a Plate</td>
    <td>IX & XI</td>
    <td>2</td>
    <td>NBH</td>
    <td></td>
  </tr>

  <tr>
    <td>o.</td>
    <td>Nukkad Natak</td>
    <td>VIII-XII</td>
    <td>10-15</td>
    <td>PVM</td>
    <td></td>
  </tr>

  {/* 16 */}
  <tr>
    <td>16</td>
    <td>Vaniya Udaan 2026</td>
    <td>KR Mangalam, GK-II</td>
    <td>31-Jul-26</td>
    <td>16-Jul-26</td>
    <td colSpan="2">Vanijya Udaan events</td>
    <td>IX-XII</td>
    <td>2</td>
    <td>RSA/SBR</td>
    <td></td>
  </tr>

  {/* 17 */}
  <tr>
    <td>17</td>
    <td>Comastitva 2026</td>
    <td>DPS, RK Puram</td>
    <td>19-Jul-26</td>
    <td>15-Jul-26</td>
    <td colSpan="2">Commerce events</td>
    <td>XI-XII</td>
    <td>2</td>
    <td>RSA</td>
    <td></td>
  </tr>

  {/* 18 */}
  <tr>
    <td rowSpan="21">18</td>
    <td rowSpan="21">Tapsfest 2026</td>
    <td rowSpan="21">APS, Dhaula Kuan</td>
    <td rowSpan="21">28-29 Jul 26</td>
    <td rowSpan="21">24-Jul-28</td>

    <td>a.</td>
    <td>Tark tantrika</td>
    <td>VI-VIII</td>
    <td>2</td>
    <td>PNM</td>
    <td></td>
  </tr>
  <tr>
    <td>b.</td>
    <td>Living palette</td>
    <td>VI-VIII</td>
    <td>2</td>
    <td>MVJ</td>
    <td></td>
  </tr>
  <tr>
    <td>c.</td>
    <td>Inno track</td>
    <td>VI-VIII</td>
    <td>2</td>
    <td>ASN</td>
    <td></td>
  </tr>
  <tr>
    <td>d.</td>
    <td>Chocomania</td>
    <td>VIII-XII</td>
    <td>2</td>
    <td>PYR</td>
    <td></td>
  </tr>
  <tr>
    <td>e.</td>
    <td>Aerosol dreams</td>
    <td>IX-XII</td>
    <td>2</td>
    <td>MVJ</td>
    <td></td>
  </tr>
  <tr>
    <td>f.</td>
    <td>Manthan</td>
    <td>IX-XII</td>
    <td>8-10</td>
    <td>PNM</td>
    <td></td>
  </tr>
  <tr>
    <td>g.</td>
    <td>TAPS Tank</td>
    <td>XI-XII</td>
    <td>2</td>
    <td>RSA</td>
    <td></td>
  </tr>
  <tr>
    <td>h.</td>
    <td>TAPS Talk</td>
    <td>XI-XII</td>
    <td>1</td>
    <td>TSC</td>
    <td></td>
  </tr>
  <tr>
    <td>i.</td>
    <td>Laugh lounge</td>
    <td>XI-XII</td>
    <td>3</td>
    <td>TSC</td>
    <td></td>
  </tr>
  <tr>
    <td>j.</td>
    <td>Prompt masters</td>
    <td>V-VII</td>
    <td>1</td>
    <td>NEG</td>
    <td></td>
  </tr>
  <tr>
    <td>k.</td>
    <td>Game Verse</td>
    <td>VI-XII</td>
    <td>1-2</td>
    <td>NEG</td>
    <td></td>
  </tr>
  <tr>
    <td>l.</td>
    <td>Inside the static</td>
    <td>VIII-XII</td>
    <td>3-4</td>
    <td>TSC</td>
    <td></td>
  </tr>
  <tr>
    <td>m.</td>
    <td>Campus canvas</td>
    <td>XI-XII</td>
    <td>2</td>
    <td>HIR/KAN</td>
    <td></td>
  </tr>
  <tr>
    <td>n.</td>
    <td>The phoenix</td>
    <td>XI-XII</td>
    <td>2</td>
    <td>RSA</td>
    <td></td>
  </tr>
  <tr>
    <td>o.</td>
    <td>Mathesis monolith</td>
    <td>X-XII</td>
    <td>2</td>
    <td>VNS</td>
    <td></td>
  </tr>
  <tr>
    <td>p</td>
    <td>Techno sphere</td>
    <td>IX-XII</td>
    <td>2</td>
    <td>NEG</td>
    <td></td>
  </tr>
  <tr>
    <td>q</td>
    <td>Frontend frenzy</td>
    <td>VI-IX</td>
    <td>2</td>
    <td>NEG</td>
    <td></td>
  </tr>
  <tr>
    <td>r</td>
    <td>Mindbot</td>
    <td>IX-XII</td>
    <td>1-2</td>
    <td>NEG</td>
    <td></td>
  </tr>
  <tr>
    <td>s</td>
    <td>Code quest</td>
    <td>VI-IX</td>
    <td>1</td>
    <td>NEG</td>
    <td></td>
  </tr>
  <tr>
    <td>t</td>
    <td>Synaptica dreams</td>
    <td>VI-VIII</td>
    <td>1-2</td>
    <td>NEG</td>
    <td></td>
  </tr>
  <tr>
    <td>u</td>
    <td>Ray trails</td>
    <td>IX-XII</td>
    <td>2-5</td>
    <td>HIR/KAN</td>
    <td></td>
  </tr>

  {/* 19 */}
  <tr>
    <td rowSpan="10">19</td>
    <td rowSpan="10">Melange Spectrum 2026</td>
    <td rowSpan="10">DPS, Dwarka</td>
    <td rowSpan="10">08-Aug-26</td>
    <td rowSpan="10">31-Jul-26</td>

    <td>a.</td>
    <td>Aerox events</td>
    <td>IX-XII</td>
    <td>2-3</td>
    <td>ASN</td>
    <td></td>
  </tr>
  <tr>
    <td>b.</td>
    <td>Crescendo</td>
    <td>VI-VIII</td>
    <td>6-8</td>
    <td>RKS</td>
    <td></td>
  </tr>
  <tr>
    <td>c.</td>
    <td>ETC-frame of mind</td>
    <td>VIII-IX</td>
    <td>2</td>
    <td>TSC</td>
    <td></td>
  </tr>
  <tr>
    <td>d.</td>
    <td>ETC-pitch perfectly</td>
    <td>XI-XII</td>
    <td>2</td>
    <td>RSA</td>
    <td></td>
  </tr>
  <tr>
    <td>e.</td>
    <td>Focus events</td>
    <td>VI-XII</td>
    <td>2</td>
    <td>HIR/KAN</td>
    <td></td>
  </tr>
  <tr>
    <td>f.</td>
    <td>Kirdaar events</td>
    <td>VI-VII</td>
    <td>6</td>
    <td>PNM</td>
    <td></td>
  </tr>
  <tr>
    <td>g.</td>
    <td>Luminarium events</td>
    <td>VI-XII</td>
    <td>2</td>
    <td>TSC</td>
    <td></td>
  </tr>
  <tr>
    <td>h.</td>
    <td>Mosaic events</td>
    <td>VI-XII</td>
    <td>2</td>
    <td>MVJ</td>
    <td></td>
  </tr>
  <tr>
    <td>i.</td>
    <td>Psynapse</td>
    <td>XI-XII</td>
    <td>2-4</td>
    <td>ACD</td>
    <td></td>
  </tr>
  <tr>
    <td>j.</td>
    <td>Robodex events</td>
    <td>VI-XII</td>
    <td>3-4</td>
    <td>NEG</td>
    <td></td>
  </tr>

  {/* 20 */}
  <tr>
    <td rowSpan="11">20</td>
    <td rowSpan="11">Meraki 2026</td>
    <td rowSpan="11">Sadhu Vaswani International School for Girls, Shanti Niketan</td>
    <td rowSpan="11">03-07 Aug 26</td>
    <td rowSpan="11">30-Jul-26</td>

    <td>a.</td>
    <td>Meraki Newsroom</td>
    <td>VI-VIII</td>
    <td>4</td>
    <td>TSC</td>
    <td></td>
  </tr>
  <tr>
    <td>b.</td>
    <td>Drama Remix</td>
    <td>IX-XI</td>
    <td>4-6</td>
    <td>TSC</td>
    <td></td>
  </tr>
  <tr>
    <td>c.</td>
    <td>Sahitya ki Meraki Udaan</td>
    <td>VI-VIII</td>
    <td>2</td>
    <td>PNM</td>
    <td></td>
  </tr>
  <tr>
    <td>d.</td>
    <td>Manch Ki Meraki</td>
    <td>IX-XI</td>
    <td>10</td>
    <td>PNM</td>
    <td></td>
  </tr>
  <tr>
    <td>e.</td>
    <td>Math &amp; Mystery Hunt</td>
    <td>VI-VIII</td>
    <td>3</td>
    <td>VNS</td>
    <td></td>
  </tr>
  <tr>
    <td>f.</td>
    <td>Ad Mad Zap</td>
    <td>IX &amp; X</td>
    <td>3</td>
    <td>VNS</td>
    <td></td>
  </tr>
  <tr>
    <td>g.</td>
    <td>Jigyasa</td>
    <td>VI-VIII</td>
    <td>8</td>
    <td>PST</td>
    <td></td>
  </tr>
  <tr>
    <td>h.</td>
    <td>A.T.I Tinkerfest</td>
    <td>IX-XI</td>
    <td>2</td>
    <td>ASN</td>
    <td></td>
  </tr>
  <tr>
    <td>i.</td>
    <td>Silent Voices</td>
    <td>IX-XI</td>
    <td>8</td>
    <td>SHD</td>
    <td></td>
  </tr>
  <tr>
    <td>j.</td>
    <td>Code Crafter</td>
    <td>VI-XII</td>
    <td>2</td>
    <td>NEG</td>
    <td></td>
  </tr>
  <tr>
    <td>k.</td>
    <td>Frame Fusion</td>
    <td>IX-XII</td>
    <td>2</td>
    <td>NEG</td>
    <td></td>
  </tr>

  {/* 21 */}
  <tr>
    <td rowSpan="2">21</td>
    <td rowSpan="2">Inter-School painting Competition</td>
    <td rowSpan="2">India Meteorological Department, Mausam Bhawan</td>
    <td rowSpan="2">06-Aug-26</td>
    <td rowSpan="2">03-Aug-26</td>
    <td colSpan="2" rowSpan="2">Painting Competition</td>
    <td>VI-VII</td>
    <td>02</td>
    <td rowSpan="2">MVJ</td>
    <td rowSpan="2"></td>
  </tr>
  <tr>
    <td>VIII-IX</td>
    <td>02</td>
  </tr>

  {/* 22 */}
  <tr>
    <td rowSpan="8">22</td>
    <td rowSpan="8">Dewang Mehta Memorial IT Symposium</td>
    <td rowSpan="8">Bhartiya Vidya Bhavan Mehta Vidyalaya</td>
    <td rowSpan="8">07-Aug-26</td>
    <td rowSpan="8">31-Jul-26</td>
    <td>a.</td>
    <td>AI Web Forge</td>
    <td>XI-XII</td>
    <td>1-2</td>
    <td rowSpan="8">NEG</td>
    <td rowSpan="8"></td>
  </tr>
  <tr>
    <td>b.</td>
    <td>Graphica</td>
    <td>VI-XII</td>
    <td>1</td>
  </tr>
  <tr>
    <td>c.</td>
    <td>Geeta Diva</td>
    <td>IX-XII</td>
    <td>1-2</td>
  </tr>
  <tr>
    <td>d.</td>
    <td>Layout lab</td>
    <td>VI-VIII</td>
    <td>1</td>
  </tr>
  <tr>
    <td>e.</td>
    <td>Pitch Strom</td>
    <td>IX-XII</td>
    <td>1-2</td>
  </tr>
  <tr>
    <td>f.</td>
    <td>Debug Duel</td>
    <td>VI-XII</td>
    <td>1-2</td>
  </tr>
  <tr>
    <td>g.</td>
    <td>Frame the truth</td>
    <td>IX-XII</td>
    <td>1-2</td>
  </tr>
  <tr>
    <td>h.</td>
    <td>Re-Brand X</td>
    <td>IX-X</td>
    <td>1</td>
  </tr>

  {/* 23 */}
  <tr>
    <td rowSpan="10">23</td>
    <td rowSpan="10">Laxaman Memorial Inter-School Competition 2026</td>
    <td rowSpan="10">Laxman Public School, Khas Enclave</td>
    <td rowSpan="10">21-Aug-26</td>
    <td rowSpan="10">12-Aug-26</td>
    <td rowSpan="2">a.</td>
    <td rowSpan="2">Sanskrit Shlok Recitation</td>
    <td>VI-VIII</td>
    <td>1</td>
    <td rowSpan="2">PNM</td>
    <td rowSpan="10"></td>
  </tr>
  <tr>
    <td>IX-XII</td>
    <td>1</td>
  </tr>
  <tr>
    <td rowSpan="2">b.</td>
    <td rowSpan="2">Hindi Poetry</td>
    <td>VI-VIII</td>
    <td>1</td>
    <td rowSpan="2">PNM</td>
  </tr>
  <tr>
    <td>IX-XII</td>
    <td>1</td>
  </tr>
  <tr>
    <td rowSpan="2">c.</td>
    <td rowSpan="2">English Poetry</td>
    <td>VI-VIII</td>
    <td>1</td>
    <td rowSpan="2">TSC</td>
  </tr>
  <tr>
    <td>IX-XII</td>
    <td>1</td>
  </tr>
  <tr>
    <td rowSpan="2">d.</td>
    <td rowSpan="2">Chitralipi</td>
    <td>VI-VIII</td>
    <td>1</td>
    <td rowSpan="2">MVJ</td>
  </tr>
  <tr>
    <td>IX-XII</td>
    <td>1</td>
  </tr>
  <tr>
    <td>e.</td>
    <td>Innovatrix</td>
    <td>IX-X</td>
    <td>2</td>
    <td>VNS</td>
  </tr>
  <tr>
    <td>f.</td>
    <td>Quark</td>
    <td>IX-X</td>
    <td>2</td>
    <td>MNG</td>
  </tr>
</tbody>
              </table>
            </div>
          </div>
          {/* 
          <div className="row">
            <div className="table-responsive maintable">
              <table className="table">
                <thead>
                  <tr>
                    <th> Sl No </th> <th> Competition </th>{" "}
                    <th> School / Venue </th> <th> Date </th>{" "}
                    <th> Last Date of Registration </th> <th> Event </th>{" "}
                    <th> Classes </th> <th> No. of Participants </th>{" "}
                    <th> Teacher Incharge </th> <th> Remarks </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {" "}
                    <td rowspan="3"> 1 </td>{" "}
                    <td rowspan="3"> Goenka Grandeur 2025 </td>{" "}
                    <td rowspan="3"> GD Goenka School, Vasant Kunj </td>{" "}
                    <td rowspan="3"> 29 Apr-02 May 25 </td>{" "}
                    <td rowspan="3"> 18 April 2025 </td>
                    <td> (a) English Elocution </td>
                    <td> XI-XII </td>
                    <td> 2 </td>
                    <td> TSC </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (b) Folk Fusion </td>
                    <td> IX-XII </td>
                    <td> 2 </td>
                    <td> MVJ </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (c) Poetry in a frame </td>
                    <td> IX-XII </td>
                    <td> 2 </td>
                    <td> MVJ </td>
                    <td></td>
                  </tr>
                  <tr>
                    {" "}
                    <td rowspan="11"> 2 </td>{" "}
                    <td rowspan="11"> Festival Della Scienza 4.0 </td>{" "}
                    <td rowspan="11"> DPS RK Puram </td>{" "}
                    <td rowspan="11"> 26 April 2025 </td>{" "}
                    <td rowspan="11"> 18th April 2025 </td>
                    <td> (a) Mappa Mentale </td>
                    <td> VI-VIII </td>
                    <td> 2 </td>
                    <td> PYM </td> <td></td>
                  </tr>
                  <tr>
                    <td> (b) Fotografia Scientifia </td>
                    <td> IX-X </td>
                    <td> 2 </td>
                    <td> ASN </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (c) Messagio bobine </td>
                    <td> XI-XII </td>
                    <td> 2 </td>
                    <td> SHB </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (d) Science Quiz </td>
                    <td> VI </td>
                    <td> 2 </td>
                    <td> PYM </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (e) Science games </td>
                    <td> VII </td>
                    <td> 2 </td>
                    <td> PYM </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (f) Role Play </td>
                    <td> VIII </td>
                    <td> 1-2 </td>
                    <td> ASN </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (g) Demonstrate the concept </td>
                    <td> IX </td>
                    <td> 2 </td>
                    <td> SHB </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (h) Discover Science </td>
                    <td> X </td>
                    <td> 2 </td>
                    <td> SHB </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (i) Creative Solution </td>
                    <td> XI-XII </td>
                    <td> 2 </td>
                    <td> ASN </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (j) Chemistry Demo </td>
                    <td> XI-XII </td>
                    <td> 2 </td>
                    <td> SHB </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (k) Innovative Biology </td>
                    <td> XI-XII </td>
                    <td> 2 </td>
                    <td> PYM </td>
                    <td></td>
                  </tr>
                  <tr>
                    {" "}
                    <td rowspan="17"> 3 </td>{" "}
                    <td rowspan="17"> Abhivyakti 2025 </td>{" "}
                    <td rowspan="17"> Gyan Mandir public School, Naraina</td>{" "}
                    <td rowspan="17"> 7-9 May 25 </td>{" "}
                    <td rowspan="17"> 17th April 2025 </td>
                    <td> (a) Culinary Alchemy </td> <td> VI-VIII </td>{" "}
                    <td> 2 </td> <td> SHB </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (b) Pyphysix Challenge </td> <td> IX-X </td>{" "}
                    <td> 2 </td> <td> ASN </td> <td></td>
                  </tr>
                  <tr>
                    <td> (c) Scibiz Innovators </td> <td> XI-XII </td>{" "}
                    <td> 1 </td> <td> PYM & RSA </td> <td></td>
                  </tr>
                  <tr>
                    <td> (d) Canva Strokes </td> <td> VI-VIII </td> <td> 2 </td>{" "}
                    <td> MVJ </td> <td></td>
                  </tr>
                  <tr>
                    <td> (e) Director's Cut </td> <td> XI-XII </td> <td> 2 </td>{" "}
                    <td> NEG </td> <td></td>
                  </tr>
                  <tr>
                    <td> (f) Mobilityx </td> <td> VI-VIII </td> <td> 2 </td>{" "}
                    <td> ASN </td> <td></td>
                  </tr>
                  <tr>
                    <td> (g) Roborace </td> <td> VI-VIII </td> <td> 2-3 </td>{" "}
                    <td> ASN </td> <td></td>
                  </tr>
                  <tr>
                    <td> (h) Healtech Challenge </td> <td> IX-XII </td>{" "}
                    <td> 2 </td> <td> PYM & NEG </td> <td></td>
                  </tr>
                  <tr>
                    <td> (i) Dot-a-pot </td> <td> VI-VII </td> <td> 2 </td>{" "}
                    <td> MVJ </td> <td></td>
                  </tr>
                  <tr>
                    <td> (j) Echoes of grandeur </td> <td> IX-X </td>{" "}
                    <td> 2 </td> <td> SHD </td> <td></td>
                  </tr>
                  <tr>
                    <td> (k) Warli glow </td> <td> IX-X </td> <td> 1 </td>{" "}
                    <td> MVJ </td> <td></td>
                  </tr>
                  <tr>
                    <td> (l) Candid Chats </td> <td> XI-XII </td> <td> 2 </td>{" "}
                    <td> TSC </td> <td></td>
                  </tr>
                  <tr>
                    <td> (m) Resin Art </td> <td> XI-XII </td> <td> 2 </td>{" "}
                    <td> MVJ </td> <td></td>
                  </tr>
                  <tr>
                    <td> (n) Voice of Cricket </td> <td> XI-XII </td>{" "}
                    <td> 2 </td> <td> MPP </td> <td></td>
                  </tr>
                  <tr>
                    <td> (o) Maths-o-groove </td> <td> IX-X </td> <td> 2 </td>{" "}
                    <td> VNS </td> <td></td>
                  </tr>
                  <tr>
                    <td> (p) Mathsymphonia </td> <td> XI-XII </td> <td> 1 </td>{" "}
                    <td> VNS </td> <td></td>
                  </tr>
                  <tr>
                    <td> (q) Baskethon </td> <td> VI-VIII </td> <td> 2 </td>{" "}
                    <td> MPP </td> <td></td>
                  </tr>
                  <tr>
                    {" "}
                    <td> 4 </td> <td> Transcendence 3.0 2025 </td>{" "}
                    <td>Air Force Bal Bharti School, Lodi Road </td>{" "}
                    <td>8-9 May 25 </td> <td> 29th April 2025</td>{" "}
                    <td> MUN </td> <td> VIII-XII </td> <td> 7 </td>{" "}
                    <td> SBR </td>{" "}
                    <td>
                      {" "}
                      <p> </p>{" "}
                    </td>{" "}
                  </tr>
                  <tr>
                    {" "}
                    <td rowspan="10">5 </td>{" "}
                    <td rowspan="10"> Ubharte Hastakshar 2025 </td>{" "}
                    <td rowspan="10">SBDAV Public School, Vasant Vihar </td>{" "}
                    <td rowspan="10"> 09 May 25 </td>{" "}
                    <td rowspan="10"> 30th April 2025 </td>
                    <td> (a) Litvibe </td> <td> IX-X </td> <td> 4 </td>{" "}
                    <td> TSC </td>
                    <td></td>
                  </tr>
                  <tr>
                    {" "}
                    <td> (b) Ted Talk </td> <td> XI-XII </td> <td> 1 </td>{" "}
                    <td> TSC </td> <td></td>
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (c) Rasrang </td> <td> IX-XII </td> <td> 1 </td>{" "}
                    <td> PNM </td>
                    <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (d) Vachnam </td> <td> VI-VIII </td> <td> 1 </td>{" "}
                    <td> PNM </td> <td></td>
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (e) Art Vessel </td> <td> IX-XII </td> <td> 2 </td>{" "}
                    <td> MVJ </td>
                    <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (f) Quill Quest </td> <td> VI-VIII </td> <td> 2 </td>{" "}
                    <td> MVJ </td> <td></td>
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (g) Ekal Abhivyakti </td> <td> VI-VIII </td>{" "}
                    <td> 1 </td> <td> PNM </td>
                    <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (h) Smart bites </td> <td> IX-XII </td> <td> 2 </td>{" "}
                    <td> NBH </td>
                    <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (i) Wholesome eats </td> <td> IX-X </td> <td> 1 </td>{" "}
                    <td> NBH </td> <td></td>
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (j) Cyber techie </td> <td> IX-XII </td> <td> 2 </td>{" "}
                    <td> NEG </td> <td></td>
                  </tr>
                  <tr>
                    {" "}
                    <td rowspan="4">6 </td>{" "}
                    <td rowspan="4">Confluence 2025 </td>{" "}
                    <td rowspan="4">
                      Air Force Golden Jubilee Institute, Subroto Park{" "}
                    </td>{" "}
                    <td rowspan="4"> 25 July 2025 </td>{" "}
                    <td rowspan="4"> 18 July 2025 </td>{" "}
                    <td> (a) Nukkad Natak </td> <td> IX-XII </td> <td> 5-6</td>{" "}
                    <td> SHD </td> <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (b) Poster Making </td> <td> XI-XII </td> <td> 1 </td>{" "}
                    <td> MVJ </td> <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (c) Biz Thrive </td> <td> XI-XII </td> <td> 3-4 </td>{" "}
                    <td> RSA </td> <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td>(d) Behind the brand </td> <td> X-XII </td> <td> 4 </td>{" "}
                    <td> RSA </td> <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td rowspan="4">7 </td> <td rowspan="4">Zenith 2025 </td>{" "}
                    <td rowspan="4">
                      Air Force Golden Jubilee Institute, Subroto Park{" "}
                    </td>{" "}
                    <td rowspan="4"> 25 July 2025 </td>{" "}
                    <td rowspan="4"> 18 July 2025 </td>{" "}
                    <td> (a) Veni Vidi Vici </td> <td> IX-XII</td> <td> 5+1</td>{" "}
                    <td> NEG </td> <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (b) Visions of rome </td> <td> IX-XII</td> <td> 2 </td>{" "}
                    <td> NEG </td> <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (c) Imago Comica </td> <td> VI-VIII </td> <td> 2 </td>{" "}
                    <td> NEG </td> <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td>(d) Iegions of laughs </td> <td>X-XII</td> <td> 1 </td>{" "}
                    <td> NEG </td> <td></td>{" "}
                  </tr>
                  <tr>
                    <td rowspan="22">8 </td>
                    <td rowspan="22">TAPSFEST 2025</td>
                    <td rowspan="22">Army Public School, Dhaula Kuan </td>
                    <td rowspan="22"> 19-20 Aug 25 </td>
                    <td rowspan="22"> 17 Aug 25 </td>
                    <td> (a) Roborace</td>
                    <td> VI-VIII</td>
                    <td> 2</td>
                    <td> ASN </td>
                    <td></td>{" "}
                  </tr>
                  <tr>
                    <td>(b) Voice through time</td>
                    <td>IX-XII</td>
                    <td>1</td>
                    <td>SHD</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (c)Science Symposium</td>
                    <td>IX-XII</td>
                    <td>2</td>
                    <td>PYM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (d) Drama in the dimension of time</td>
                    <td>IX-XII</td>
                    <td>5</td>
                    <td>TSC</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (e)Hemlines to headlines</td>
                    <td>IX-XII</td>
                    <td>3</td>
                    <td>SHD</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (f) The Chronos</td>
                    <td>XI-XII</td>
                    <td>2</td>
                    <td>RSA</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (g) Filmic fusion</td>
                    <td>IX-XII</td>
                    <td>2</td>
                    <td>NEG</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (h) Nukkad Natak</td>
                    <td>IX-XII</td>
                    <td>8–10</td>
                    <td>PNM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (i) Time-travelling</td>
                    <td>IX-XII</td>
                    <td>1</td>
                    <td>TSC</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (j) Code Craft</td>
                    <td>XI-XII</td>
                    <td>1</td>
                    <td>NEG</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (k) Bake to the future</td>
                    <td>X-XII</td>
                    <td>2</td>
                    <td>NBH</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (l) Abstraction to lippan</td>
                    <td>VI-VIII</td>
                    <td>2</td>
                    <td>MVJ</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (m) Insight-X</td>
                    <td>VI-VIII</td>
                    <td>1</td>
                    <td>NEG</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (n) Reimagine the classics</td>
                    <td>IX-X</td>
                    <td>2</td>
                    <td>MVJ</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (o) Jam-a-logue</td>
                    <td>IX-XII</td>
                    <td>1</td>
                    <td>TSC</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>(p) Mathmorphosis</td>
                    <td>IX-XII</td>
                    <td>2</td>
                    <td>NER</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>(q) Temporal titans</td>
                    <td>IX-XII</td>
                    <td>2–3</td>
                    <td>RSA</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>(r) Totem pole</td>
                    <td>XI-XII</td>
                    <td>2</td>
                    <td>TMG</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (s) Cryptic Hunt</td>
                    <td>X-XII</td>
                    <td>1</td>
                    <td>NEG</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>(t) Culinary time capsule</td>
                    <td>X-XII</td>
                    <td>1</td>
                    <td>NBH</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (u) Chiming Creations (CWSN event)</td>
                    <td>VIII-XII</td>
                    <td>2</td>
                    <td>SMA</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (v) Pixel epoch (CWSN event)</td>
                    <td>IX-XII</td>
                    <td>1</td>
                    <td>SMA</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowspan="6">9</td>
                    <td rowspan="6">Ramjas Inter School Debate 2025</td>
                    <td rowspan="6">Ramjas School, Pusa Road </td>
                    <td rowspan="6">
                      29 & 30 Oct (Eng) <br /> 31 Oct & 01 Nov (hindi)
                    </td>
                    <td rowspan="6"> 25 Sep 25 </td>
                    <td>Eng Debate</td>
                    <td>IX-XII</td>
                    <td>2</td>
                    <td>TSC</td>
                    <td></td>{" "}
                  </tr>
                  <tr>
                    <td>Hindi Debate</td>
                    <td>IX-XII</td>
                    <td>2</td>
                    <td>PNM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Aeon events</td>
                    <td>IX-XII</td>
                    <td>1-4</td>
                    <td>SHD</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Axiom events</td>
                    <td>VI-XII</td>
                    <td>2-6</td>
                    <td>NER</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Core events</td>
                    <td>IX-XII</td>
                    <td>1-6</td>
                    <td>NEG</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Ecophoria events</td>
                    <td>IX-XII</td>
                    <td>2-3</td>
                    <td>SBR</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowspan="8">10</td>
                    <td rowspan="8">Spectrum 2025</td>
                    <td rowspan="8">DPS, Dwarka </td>
                    <td rowspan="8">11 Oct 25</td>
                    <td rowspan="8"> 3 Oct 25 </td>
                    <td>ETC events</td>
                    <td>IX–XII</td>
                    <td>2–4</td>
                    <td>TSC</td>
                    <td></td>{" "}
                  </tr>
                  <tr>
                    <td>Flux events</td>
                    <td>VI–XII</td>
                    <td>3</td>
                    <td>ASN</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Genesis</td>
                    <td>VI–XII</td>
                    <td>2–3</td>
                    <td>PYM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Ionista</td>
                    <td>VIII–XII</td>
                    <td>2–5</td>
                    <td>MNG</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Iuminarivm</td>
                    <td>VI–XII</td>
                    <td>1–5</td>
                    <td>TSC</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Mosaic</td>
                    <td>VI–XII</td>
                    <td>1–2</td>
                    <td>MVJ</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Psynapse</td>
                    <td>XI–XII</td>
                    <td>1–3</td>
                    <td>ACD</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Kirdaar</td>
                    <td>VI–XII</td>
                    <td>3–4</td>
                    <td>PNM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>Technoranza 2025</td>
                    <td>Bal Bharti Public School, Ganga Ram Hospital Marg</td>
                    <td>17-Oct-25</td>
                    <td>5-Oct-25</td>
                    <td>Technovanza events</td>
                    <td>VI-XII</td>
                    <td>1-2</td>
                    <td>NEG</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowspan="5">12</td>
                    <td rowspan="5">Anubhav 2025</td>
                    <td rowspan="5">Air Force School ASTE Bangalore </td>
                    <td rowspan="5">22 Nov 25</td>
                    <td rowspan="5"> 28 Oct 25 </td>
                    <td>Swar Lahori (Online)</td>
                    <td>VI-IX</td>
                    <td>1</td>
                    <td>RKS</td>
                    <td></td>{" "}
                  </tr>
                  <tr>
                    <td>Sholka Suman (Online)</td>
                    <td>VI-IX</td>
                    <td>1</td>
                    <td>PNM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Tales on Strings (Online)</td>
                    <td>VI-VIII</td>
                    <td>1</td>
                    <td>TSC</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Young tycoons (Online)</td>
                    <td>IX-XI</td>
                    <td>2</td>
                    <td>RSA</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Word Whirl (Online)</td>
                    <td>IX-XI</td>
                    <td>1</td>
                    <td>TSC</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowSpan="2">13</td>
                    <td rowSpan="2">Y Kumar Memorial Contest 2026</td>
                    <td rowSpan="2">Springdales School, Pusa Road</td>
                    <td rowSpan="2">22 Jan 2026 and 2 Feb 2026 </td>
                    <td rowSpan="2">18 Jan 2026 </td>
                    <td>Quiz & Essay Writing</td>
                    <td>XI-XII</td>
                    <td>2</td>
                    <td>DAT</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Painting</td>
                    <td>VI-VIII</td>
                    <td>2</td>
                    <td>MVJ</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowSpan="5">14</td>
                    <td rowSpan="5">
                      Annual Inter-School Garden Festival 2026
                    </td>
                    <td rowSpan="5">Cambridge School, Srinivaspuri</td>
                    <td rowSpan="5">30 Jan 2026 </td>
                    <td rowSpan="5">20 Jan 2026 </td>
                    <td>(a) Plantelligence</td>
                    <td>VII-VIII</td>
                    <td>2</td>
                    <td>PYM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>(b) Nature's nest</td>
                    <td>VI-VIII</td>
                    <td>2</td>
                    <td>PYM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>(c) Terrabloom</td>
                    <td>VI-VIII</td>
                    <td>2</td>
                    <td>PYM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>(d) Pebble Palette</td>
                    <td>VIII-IX</td>
                    <td>2</td>
                    <td>PYM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>(e) CultiCraft</td>
                    <td>VI-X</td>
                    <td>2</td>
                    <td>PYM</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div> 
          */}
        </div>
      </div >
    </>
  );
};

export default InterSchoolCorner;
